<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-8 d-none d-lg-block">
          <div class="row">
            <div class="col-md-4">
              <h4>{{ $t('about') }}</h4>
              <ul>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'introduction' }">{{ $t('introduction.title') }}</router-link>
                </li>
                <!-- <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'founder' }">{{ $t('founder.title') }}</router-link>
                </li> -->
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'chairman' }">{{ $t('chairman.title') }}</router-link>
                </li>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'library' }" v-if="$i18n.locale === 'tw'">{{ $t('library.title') }}</router-link>
                </li>
                <li style="font-size: 1.4rem">
                   <router-link :to="{ name: 'contact-information' }">{{ $t('contact.title') }}</router-link>
                 </li>
                 <li style="font-size: 1.4rem">
                   <router-link :to="{ name: 'traffic' }" v-if="$i18n.locale === 'tw'">{{ $t('traffic.title') }}</router-link>
                 </li>
                 <li style="font-size: 1.4rem">
                   <router-link :to="{ name: 'support-donation' }">{{ $t('donation.title') }}</router-link>
                 </li>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'recruitments' }" v-if="$i18n.locale === 'tw'">{{ $t('recruitment.title') }}</router-link>
                </li>
              </ul>
            </div>
            <div class="col-md-4" v-if="$i18n.locale === 'tw'">
              <h4>{{ $t('announcement') }}</h4>
              <ul>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'bulletins' }">{{ $t('bulletin.title') }}</router-link>
                </li>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'sidelights' }">{{ $t('sidelight.title') }}</router-link>
                </li>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'weeklies' }">{{ $t('weekly.title') }}</router-link>
                </li>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'monthlies' }">{{ $t('monthly.title') }}</router-link>
                </li>
              </ul>
            </div>
            <div class="col-md-4" v-if="$i18n.locale === 'tw'">
              <h4>{{ $t('activitie') }}</h4>
              <ul>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'today-courses' }">{{ $t('course.title') }}</router-link>
                </li>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'latest-session-in-colleges' }">{{ $t('academy.title') }}</router-link>
                </li>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'latest-events' }">{{ $t('hwadzan-garden.title') }}</router-link>
                </li>
              </ul>
            </div>
            <div class="col-md-4">
              <h4>{{ $t('resource') }}</h4>
              <ul>
                <li style="font-size: 1.4rem">
                  <router-link
                    :to="{ name: 'books', params: { group: 'applicable', language: ($i18n.locale === 'tw' ? 'chinese' : 'english') }}"
                  >{{ $t('book.title') }}</router-link>
                </li>
                <li style="font-size: 1.4rem" v-if="$i18n.locale === 'tw'">
                  <router-link :to="{ name: 'lendable-books' }">{{ $t('search.type-selector.option.lendable_book.label') }}</router-link>
                </li>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'recently-added-series' }">{{ $t('series.title') }}</router-link>
                </li>
                <li style="font-size: 1.4rem">
                  <router-link
                    :to="{ name: 'pictures', params: { group: 'applicable' } }"
                  >{{ $t('picture.title') }}</router-link>
                </li>
                <li style="font-size: 1.4rem" v-if="$i18n.locale === 'tw'">
                  <router-link :to="{ name: 'buddhist-dictionary-tool' }">{{ $t('buddhist-dictionary.title') }}</router-link>
                </li>
                <li style="font-size: 1.4rem" v-if="$i18n.locale === 'tw'">
                  <router-link :to="{ name: 'buddha-educational-animation' }">{{ $t('animation.title') }}</router-link>
                </li>
              </ul>
            </div>
            <!-- <div class="col-md-4">
              <h4>佛學概要</h4>
              <ul>
                <li><router-link to="/examples" style="font-size: 1.4rem">佛法基礎</router-link></li>
                <li><router-link to="/examples" style="font-size: 1.4rem">佛經選讀</router-link></li>
                <li><router-link to="/examples" style="font-size: 1.4rem">各宗祖師傳記</router-link></li>
                <li><router-link to="/examples" style="font-size: 1.4rem">佛典故事</router-link></li>
              </ul>
            </div> -->
            <div class="col-md-4" v-if="$i18n.locale === 'tw'">
              <h4>{{ $t('compassion.title') }}</h4>
              <ul>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'love-life-articles', params: { type: 'sutra' }}">{{ $t('life-caring-article') }}</router-link>
                </li>
                <!-- <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'love-life-resources', params: { type: 'cookbook' }}">護生素食譜</router-link>
                </li> -->
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'love-life-resources', params: { type: 'calendar' }}">{{ $t('life-caring-monthly-calendar') }}</router-link>
                </li>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'love-life-resources', params: { type: 'cartoon' }}">{{ $t('life-caring-picture') }}</router-link>
                </li>
                <!-- <li><router-link to="/examples" style="font-size: 1.4rem">環保園地</router-link></li> -->
                <!-- <li><router-link to="/examples" style="font-size: 1.4rem">活動花絮</router-link></li> -->
              </ul>
            </div>
            <div class="col-md-4" v-if="$i18n.locale === 'tw'">
              <h4>{{ $t('partner') }}</h4>
              <ul>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'amtb' }">{{ $t('amtb.title') }}</router-link>
                </li>
                <li style="font-size: 1.4rem">
                  <router-link :to="{ name: 'other-website' }">{{ $t('other-website.title') }}</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-12">
              <h4>{{ $t('contact.detail.value.name') }}</h4>
              <!-- <iframe src="https://www.google.com/maps/dir//%E8%B2%A1%E5%9C%98%E6%B3%95%E4%BA%BA%E4%BD%9B%E9%99%80%E6%95%99%E8%82%B2%E5%9F%BA%E9%87%91%E6%9C%83,%20100%E5%8F%B0%E5%8C%97%E5%B8%82%E4%B8%AD%E6%AD%A3%E5%8D%80%E6%9D%AD%E5%B7%9E%E5%8D%97%E8%B7%AF%E4%B8%80%E6%AE%B555%E8%99%9F" width="100%" height="300" frameborder="0" style="border:0" allowfullscreen target="_parent"></iframe> -->
              <p>
                {{ $t('contact.detail.label.address') }}: <a href="https://www.google.com/maps/dir//%E8%B2%A1%E5%9C%98%E6%B3%95%E4%BA%BA%E4%BD%9B%E9%99%80%E6%95%99%E8%82%B2%E5%9F%BA%E9%87%91%E6%9C%83,%20100%E5%8F%B0%E5%8C%97%E5%B8%82%E4%B8%AD%E6%AD%A3%E5%8D%80%E6%9D%AD%E5%B7%9E%E5%8D%97%E8%B7%AF%E4%B8%80%E6%AE%B555%E8%99%9F" target="_blank">{{ $t('contact.detail.value.address') }}&nbsp;<i class="fa fa-map-marker fa-lg"></i></a><br>
                {{ $t('contact.detail.label.telephone') }}: <a href="tel:+886-2-2395-1198">{{ $t('contact.detail.value.telephone') }}&nbsp;<i class="fa fa-phone fa-lg"></i></a><br>
                {{ $t('contact.detail.label.email') }}: <a href="mailto:budaedu@budaedu.org">{{ $t('contact.detail.value.email') }}&nbsp;<i class="fa fa-envelope-o fa-lg"></i></a><br>
                {{ $t('contact.detail.label.fax') }}: {{ $t('contact.detail.value.fax') }}<br>
                {{ $t('contact.detail.label.fax-hotline-for-dharma-application') }}: {{ $t('contact.detail.value.fax-hotline-for-dharma-application') }}<br>
                {{ $t('contact.detail.label.url') }}: <a href="https://www.budaedu.org" target="_blank">{{ $t('contact.detail.value.url') }}</a><br>
                <router-link :to="{ name: 'contact-information' }">{{ $t('contact.title') }}</router-link>
                <span v-if="$i18n.locale === 'tw'"> | </span> 
                <router-link :to="{ name: 'traffic' }" v-if="$i18n.locale === 'tw'">{{ $t('traffic.title') }}</router-link>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <!-- <p>
                <a target="_blank" href="javascript:void(0);" class="btn btn-neutral btn-icon-only btn-line btn-round btn-lg" data-toggle="tooltip" data-original-title="Subscription us">
                  <font-awesome-icon icon="fa-brands fa-line" size="2xl"></font-awesome-icon>
                </a>Line
              </p> -->
              <!-- <p>
                <a target="_blank" href="javascript:void(0);" class="btn btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip" data-original-title="Like us">
                  <i class="fa fa-facebook fa-lg"></i>
                </a>Facebook
              </p> -->
              <!-- <p>
                <a target="_blank" href="javascript:void(0);" class="btn btn-neutral btn-icon-only btn-instagram btn-lg btn-round" data-toggle="tooltip" data-original-title="Follow us">
                  <i class="fa fa-instagram"></i>
                </a>Instagram
              </p> -->
              <p>
                <a
                  href="https://www.youtube.com/channel/UCbRm1AZ3Rg9LgZ90t88RHqg"
                  target="_blank"
                  class="btn btn-neutral btn-icon-only btn-youtube btn-round btn-lg"
                  data-toggle="tooltip"
                  data-original-title="Subscription us"
                >
                  <i class="fa fa-youtube-play fa-lg"></i>
                </a>
                <a
                  href="https://www.youtube.com/channel/UCbRm1AZ3Rg9LgZ90t88RHqg"
                  target="_blank"
                >Youtube</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-12">
          <div class="copyright">
            <p>
              &copy; 2000-{{ year }} 財團法人佛陀教育基金會版權所有<br>
              &copy; 2000-{{ year }} The Corporate Body of the Buddha Educational Foundation. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'

/* add fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faLine } from '@fortawesome/free-brands-svg-icons'

import i18n from '@/plugins/i18n.js'

Vue.use(VueLocalStorage)

/* add icons to the library */
library.add(faLine)

export default {
  i18n,
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    this.$i18n.locale = this.$localStorage.get('ui-lang', 'tw')
  },
  components: {
    FontAwesomeIcon
  }
};
</script>
